class SaleInClient{

    constructor(nameClient, saleBuy) {
        this.nameClient = nameClient
        this.saleBuy = saleBuy
    }

}

export default SaleInClient